import { gql } from '@apollo/client'

export const CORE_ROLE_FIELDS = gql`
  fragment RoleFields on Role {
    id
    name
    isInternal
    isHourly
    isEditable
    description
    isActive
    meta
    clientId
    linkedUsers
    permissions {
      id
      name
      action
      target
      description
      modulator
    }
  }
`

export const ROLES_DATA = gql`
  ${CORE_ROLE_FIELDS}
  query GetRoles(
    $id: ID
    $search: String
    $orderBy: RoleOrderBy
    $orderDirection: OrderDirection
  ) {
    roles(
      rolesParams: {
        roleId: $id
        search: $search
        orderBy: $orderBy
        orderDirection: $orderDirection
      }
    ) {
      ...RoleFields
    }
  }
`

export const ROLES_IDS_AND_NAMES = gql`
  query GetRolesIdsAndNames {
    roles {
      id
      name
      isInternal
    }
  }
`

//TODO: Is active is static - currently set to true
export const CREATE_ROLE = gql`
  ${CORE_ROLE_FIELDS}
  mutation CreateRole(
    $name: String!
    $description: String
    $isInternal: Boolean
    $isHourly: Boolean
    $permissions: [ID!]!
  ) {
    createRole(
      role: {
        name: $name
        description: $description
        permissions: $permissions
        isInternal: $isInternal
        isHourly: $isHourly
        isActive: true
      }
    ) {
      ...RoleFields
    }
  }
`

export const UPDATE_ROLE = gql`
  ${CORE_ROLE_FIELDS}
  mutation UpdateRole($id: ID!, $role: RoleUpdate!) {
    updateRole(id: $id, role: $role) {
      ...RoleFields
    }
  }
`

export const DELETE_ROLE = gql`
  mutation DeleteRole($id: ID!) {
    deleteRole(id: $id)
  }
`
